import { render, staticRenderFns } from "./TotalAmounts.vue?vue&type=template&id=1a043a30&"
import script from "./TotalAmounts.vue?vue&type=script&lang=js&"
export * from "./TotalAmounts.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmounts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports